import { render, staticRenderFns } from "./MiniProfile.vue?vue&type=template&id=2d9491e1&"
import script from "./MiniProfile.vue?vue&type=script&lang=js&"
export * from "./MiniProfile.vue?vue&type=script&lang=js&"
import style0 from "./MiniProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports